export default __webpack_public_path__ + "images/b9367da4f7a709acef7cb4e5ad11feff-SunjyaProfile.png";